import hljs from "highlight.js/lib/core";

import bash from "highlight.js/lib/languages/bash";
import dockerfile from "highlight.js/lib/languages/dockerfile";
import dos from "highlight.js/lib/languages/dos";
import gradle from "highlight.js/lib/languages/gradle";
import java from "highlight.js/lib/languages/java";
import plaintext from "highlight.js/lib/languages/plaintext";
import properties from "highlight.js/lib/languages/properties";
import sql from "highlight.js/lib/languages/sql";
import xml from "highlight.js/lib/languages/xml";

// register languages
hljs.registerLanguage("bash", bash); // bash, sh, zsh
hljs.registerLanguage("dockerfile", dockerfile); // dockerfile, docker
hljs.registerLanguage("dos", dos); // dos, bat, cmd
hljs.registerLanguage("gradle", gradle); // gradle
hljs.registerLanguage("java", java); // java, jsp
hljs.registerLanguage("plaintext", plaintext); // plaintext, text, txt
hljs.registerLanguage("properties", properties); // properties
hljs.registerLanguage("sql", sql); // sql
hljs.registerLanguage("xml", xml); // xml, html, xhtml, rss, atom, xjb, xsd, xsl, plist, wsf, svg

// highlight code
hljs.highlightAll();
